import styled from '@emotion/styled';
import { Grid } from '@kc-console/common-ui';

import type { GridProps } from '@kc-console/common-ui';
import type { DefaultComponentProps } from './types';

interface WrapperProps extends DefaultComponentProps, GridProps {
  /**
   * 패널 방향 (V2)
   * - 'column': 하단 패널 (ListLayout)
   * - 'row': 우측 패널 (DetailLayout)
   */
  flexDirection?: 'column' | 'row';
}

export const LayoutWrapper = (props: WrapperProps) => {
  const { className, children, flexDirection = 'column', ...others } = props;

  return (
    <LayoutWrapperRoot container flexDirection={flexDirection} className={className} {...others}>
      {children}
    </LayoutWrapperRoot>
  );
};

export const LayoutContentSectionWrapper = (props: WrapperProps) => {
  const { className, children, ...others } = props;

  return (
    <LayoutContentSectionWrapperRoot
      className={className}
      container
      flexDirection="column"
      size="grow"
      {...others}
    >
      {children}
    </LayoutContentSectionWrapperRoot>
  );
};

export const LayoutBannerContainerWrapper = styled(Grid)``;

export const LayoutHeaderContainerWrapper = styled(Grid)`
  padding: 16px 32px;
`;

export const LayoutBodyContainerWrapper = styled(Grid)``;

export const LayoutSplitSectionWrapper = styled(Grid)`
  box-shadow: ${({ theme }) => theme.elevation.level_3};
`;

const LayoutWrapperRoot = styled(Grid)`
  width: 100%;
  height: 100%;
  flex-wrap: nowrap;
`;

const LayoutContentSectionWrapperRoot = styled(Grid)`
  flex-wrap: nowrap;
`;
